/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type G2StateTokenDto = {
    state?: string;
    status: G2StateTokenDto.status;
};

export namespace G2StateTokenDto {

    export enum status {
        SUCCESS = 'SUCCESS',
        CONFIG_MISSING = 'CONFIG_MISSING',
    }


}
